import React from 'react';

/**
 * TMC Survey logo, rendered on a white pill/card so the colored mark
 * always pops regardless of the surrounding page background.
 */
const Logo = ({ size = 'md', showTagline = false, className = '' }) => {
  const dimensions = {
    sm: { box: 'h-10 px-3', img: 'h-7' },
    md: { box: 'h-16 px-4', img: 'h-12' },
    lg: { box: 'h-24 px-6', img: 'h-20' },
    xl: { box: 'h-32 px-8', img: 'h-28' },
  }[size] || { box: 'h-16 px-4', img: 'h-12' };

  return (
    <div className={`inline-flex flex-col items-center ${className}`}>
      <div
        className={`bg-white rounded-2xl shadow-sm border border-[#E5E0D8] flex items-center justify-center ${dimensions.box}`}
        data-testid="tmc-logo"
      >
        <img
          src="/tmc-survey-logo.png"
          alt="TMC Survey"
          className={`${dimensions.img} w-auto object-contain`}
          draggable={false}
        />
      </div>
      {showTagline && (
        <p className="mt-3 text-xs uppercase tracking-[0.2em] text-[#5C635A]">
          Surveys Made Simple · Insights Made Powerful
        </p>
      )}
    </div>
  );
};

export default Logo;
